import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import SiteNav from "../components/SiteNav";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const { refresh } = useAuth();
  const [status, setStatus] = useState("pending");
  const [attempts, setAttempts] = useState(0);
  const [planId, setPlanId] = useState(null);

  useEffect(() => {
    if (!sid) return;
    let cancelled = false;
    const poll = async (n=0) => {
      if (n >= 8 || cancelled) { if (!cancelled) setStatus("timeout"); return; }
      try {
        const r = await api.get(`/subscription/status/${sid}`);
        if (r.data.plan_id) setPlanId(r.data.plan_id);
        if (r.data.payment_status === "paid") { setStatus("paid"); refresh(); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
      } catch { /* ignore */ }
      setAttempts(n+1);
      setTimeout(() => poll(n+1), 2000);
    };
    poll(0);
    return () => { cancelled = true; };
  }, [sid]); // eslint-disable-line

  const isStarterGuide = planId === "starter_guide_17";
  const successDest = isStarterGuide ? "/dashboard/starter-guide" : "/dashboard";
  const successLabel = isStarterGuide ? "Open Your Starter Guide" : "Enter Dashboard";
  const successMessage = isStarterGuide
    ? "Your Starter Guide Bundle is ready — videos, PDF, and bonuses are waiting for you."
    : "Your subscription is active. Welcome to the Kingdom family.";

  return (
    <div className="min-h-screen bg-ivory">
      <SiteNav />
      <div className="max-w-2xl mx-auto px-6 py-20 text-center" data-testid="checkout-success-page">
        {status === "pending" && (<>
          <h1 className="font-serif-display text-4xl text-red-wine">Confirming your blessing…</h1>
          <p className="text-foreground mt-3">Checking payment (attempt {attempts+1}/8)</p>
        </>)}
        {status === "paid" && (<>
          <h1 className="font-serif-display text-5xl text-red-wine">Amen! You're in.</h1>
          <div className="divider-gold"></div>
          <p className="text-foreground mt-3">{successMessage}</p>
          <Link to={successDest} className="btn-primary inline-block mt-8">{successLabel}</Link>
        </>)}
        {(status === "expired" || status === "timeout") && (<>
          <h1 className="font-serif-display text-4xl text-red-wine">Something went amiss</h1>
          <p className="text-foreground mt-3">We couldn't confirm the payment. Please try again or contact support.</p>
          <Link to="/pricing" className="btn-outline-gold inline-block mt-6">Back to Pricing</Link>
        </>)}
      </div>
    </div>
  );
}
